import React from 'react';
import { CardMedia, Stack, Typography } from '@mui/material';

const StepsWeb = () => (
  <Stack px="75px" gap={10} alignItems="center" justifyContent="center" sx={{ py: 10, backgroundColor: 'white' }}>
    <Typography color="#121212" fontWeight="700" fontSize={48}>
      Just a few steps to get this done..
    </Typography>
    <CardMedia
      component="img"
      className=""
      src="assets/images/Inspection/stepsWeb.webp"
      alt="Card Image"
      // height={isMobile ? 25 : 40}
      sx={{ objectFit: 'contain', aspectRatio: '16/9', width: '100%' }}
    />
  </Stack>
);
export default StepsWeb;
